import { Button, Input, Select, message } from "antd";
import { Col, Container, Hidden, Row } from "react-grid-system";
import { usePrebookingRequest } from "../data/PrebookingRequest";
import { usePrebookingResponse } from "../data/PrebookingResponse";
import { RightOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDiscounts } from "../data/Discounts";
import { useEvent } from "../data/Event";


interface ChooseRoleProps {
    messageApi: ReturnType<typeof message.useMessage>[0];
}

export default function ChooseRole(props: ChooseRoleProps) {
    const createNewPrebooking = usePrebookingRequest(state => state.createNewPrebooking);
    const resetPrebookingResponse = usePrebookingResponse(state => state.resetPrebookingResponse);
    const navigate = useNavigate();
    const discounts = useDiscounts(state => state.discounts);
    const fetchAndSetDiscounts = useDiscounts(state => state.fetchAndSetDiscounts);
    const updateDiscount = usePrebookingRequest(state => state.updateDiscount);
    const updateDiscountCode = usePrebookingRequest(state => state.updateDiscountCode);
    const checkDiscountCode = usePrebookingRequest(state => state.checkDiscountCode);
    const preBookingRequest = usePrebookingRequest(state => state.prebooking);
    const fetchAndSetEvent = useEvent(state => state.fetchAndSetEvent);
    const [displayDiscountCode, setDisplayDiscountCode] = useState(false);
    const [discountCode, setDiscountCode] = useState("");
    const [discountCodeDisabled, setDiscountCodeDisabled] = useState(false);
    const [discountCodeApplied, setDiscountCodeApplied] = useState(false);
    const [wsdcId, setWsdcId] = useState<string>("");
    const [nextDisabled, setNextDisabled] = useState(false);
    const setWsdcIdInRequest = usePrebookingRequest(state => state.setWSDCId);


    const [searchParams] = useSearchParams();
    const eventId = Number(searchParams.get("id")) ?? 0;

    useEffect(() => {
        fetchAndSetEvent(eventId, () => { });
        fetchAndSetDiscounts();
        createNewPrebooking(eventId);
        resetPrebookingResponse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onDiscountChange(discountId: number) {
        if (discountId === 0) {
            setDiscountCodeDisabled(true);
            setDisplayDiscountCode(false);
        }
        else if (discountId === 1337) {
            setDisplayDiscountCode(true);
            setDiscountCodeDisabled(false);
            setNextDisabled(false);
            updateDiscount(0, () => { });
            return;
        }
        else {
            setDiscountCodeDisabled(true);
            setDisplayDiscountCode(false);
        }

        if (discountId === 3 || discountId === 4) {
            if (wsdcId === "") {
                props.messageApi.info("Please provide your WSDC-Id.");
                setNextDisabled(true);
            }
        } else {
            setNextDisabled(false);
        }

        updateDiscount(discountId, () => { })
    }

    function onDiscountChangeCode(discountCode: string) {
        setDiscountCode(discountCode);
    }

    async function applyDiscountCode() {
        if (discountCode !== "") {
            var isValid = await checkDiscountCode(discountCode.trim());
            if (isValid) {
                setDiscountCodeApplied(true);
                updateDiscountCode(discountCode.trim(), () => { });
            } else
                props.messageApi.error("The discount code is invalid.");
        }
    }

    function removeDiscountCode() {
        setDiscountCodeApplied(false);
        updateDiscountCode(null, () => { });
    }

    function onWsdcIdChange(wsdcId: string) {
        setWsdcId(wsdcId);
        setWsdcIdInRequest(wsdcId);
        if (preBookingRequest?.discount === 3 || preBookingRequest?.discount === 4) {
            if (wsdcId === "") {
                setNextDisabled(true);
            } else {
                setNextDisabled(false);
            }
        }
    }

    return (
        <Container>
            <Row gutterWidth={25} style={{
                backgroundColor: "white", borderRadius: "10px", padding: "20px 20px 80px 20px",
                boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)"
            }}>
                <Col md={12} style={{ marginBottom: 0 }}>
                    <Hidden xs sm>
                        <h1 style={{ textAlign: "left", marginTop: 0, marginBottom: 0, color: "black" }}>Information</h1>
                    </Hidden>
                    <Hidden md lg xl xxl xxxl>
                        <h1 style={{ textAlign: "center", marginTop: 0, marginBottom: 0, color: "black" }}>Information</h1>
                    </Hidden>
                </Col>
                <Col md={6} style={{ textAlign: "left" }}>
                    <p style={{ marginBottom: "0px" }}><b>WSDC-Id</b></p>
                    <p style={{ marginTop: "2px", fontSize: "0.8rem" }}><i>You have a WSDC number? Please provide it here.</i></p>
                    <Input placeholder="1234" value={wsdcId} onChange={e => { onWsdcIdChange(e.target.value); }}></Input>
                </Col>
                <Col md={6} style={{ textAlign: "left" }}>
                    <p style={{ marginBottom: "0px" }}><b>Discount</b></p>
                    <p style={{ marginTop: "2px", fontSize: "0.8rem" }}><i>You have a discount code, or are Advanced/Allstar? Please choose your discount here.</i></p>
                    <div>
                        <Select disabled={discountCodeApplied} onChange={onDiscountChange} defaultValue={0} style={{ width: "250px", textAlign: "left" }}>
                            <Select.Option value={0} >None</Select.Option>
                            {discounts.map(discount => (
                                <Select.Option key={discount.id} value={discount.id}>{discount.name}</Select.Option>
                            ))}
                            <Select.Option value={1337}>Code</Select.Option>
                        </Select>
                    </div>
                    <div style={{ display: displayDiscountCode ? "block" : "none", marginTop: "4px" }}>
                        <p style={{ marginBottom: "0px" }}><i>Code:</i></p>
                        <Input disabled={discountCodeDisabled} style={{ width: "150px", textAlign: "left" }} value={discountCode} onChange={e => onDiscountChangeCode(e.target.value)} />

                        {!(discountCodeApplied) ?
                            <Button disabled={discountCodeDisabled} style={{ marginLeft: "5px" }} type="primary" onClick={() => applyDiscountCode()}>Apply</Button>
                            : null
                        }
                        {!discountCodeDisabled && discountCodeApplied ?
                            <Button style={{ marginLeft: "5px" }} type="primary" danger onClick={() => removeDiscountCode()}>Remove</Button>
                            : null
                        }
                    </div>
                </Col>
            </Row>
            <Row style={{ marginTop: "20px" }}>
                <Col xl={12}>
                    <div style={{ textAlign: "right" }}>
                        <Button size="large" type="primary" onClick={() => { navigate("/individual"); console.log(preBookingRequest) }}
                            disabled={preBookingRequest == null || nextDisabled}>Next <RightOutlined /></Button>
                    </div>
                </Col>
            </Row>
        </Container >
    );
}